import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { FontAwesomeModule, FaIconLibrary, FaConfig } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import { ConfirmationService, MessageService, TreeDragDropService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';

import { HeaderComponent } from './header/header.component';
import { AppRoutingModule } from './app-routing.module';
import { StartComponent } from './start/start.component';
import { AuthInterceptor } from './auth.interceptor';
import { CoreUIModule } from './core-ui/core-ui.module';
import { SectionsModule } from './sections/sections.module';

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		StartComponent,
	],
	imports: [
		AppRoutingModule,
		BrowserAnimationsModule,
		BrowserModule,
		CoreUIModule,
		HttpClientModule,

		FontAwesomeModule,

		ButtonModule,
		ConfirmDialogModule,
		ConfirmPopupModule,
		MenuModule,
		MenubarModule,
		ToastModule,

		SectionsModule
	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		ConfirmationService,
		MessageService,
		TreeDragDropService,
	],
	bootstrap: [AppComponent]
})
export class AppModule
{
	constructor(library: FaIconLibrary, faConfig: FaConfig)
	{
		library.addIconPacks(fas, far, fab);
		faConfig.defaultPrefix = 'fas';
	}
}
